import { defineStore } from 'pinia';
import { ref } from 'vue';
import AuthenticationService from '../services/authentication-service';
import SignupRequest from '../requests/SingupRequest';
import SigninRequest from '../requests/SigninRequest';
import DeepLinkRequest from '../requests/DeepLinkRequest';

export const useAuthStore = defineStore('auth', () => {
  const isAuthenticated = ref<boolean>(false)
  const member = ref<{
    memberId?: string
  }>({})

  const signup = async (signupRequest: SignupRequest) => {
    try {
      const response = await AuthenticationService.signup(signupRequest)
      if (response?.isSuccess === true) {        
        isAuthenticated.value = true             
      }      
      if (!response) {
        throw new Error('Signin failed: No response received');
      }
      return response
    } catch (error) {
      throw error;
    }
  }

  const signin = async (signinRequest: SigninRequest) => {
    try {
      const response = await AuthenticationService.signin(signinRequest)     
      
      if (response?.isSuccess === true) {        
        isAuthenticated.value = true
        member.value = {
          memberId: response.memberId.toString()
        }        
      }      
      return response
    } catch (error) {
      throw error
    }
  }

  const deepLinkSignin = async (deepLinkRequest: DeepLinkRequest) => {
    try {
      const response = await AuthenticationService.deepLinkSignin(deepLinkRequest)     
      
      if (response?.isSuccess === true) {        
        isAuthenticated.value = true
        member.value = {
          memberId: response.memberId.toString()
        }        
      }      
      return response
    } catch (error) {
      throw error
    }
  }

  const signout = async () => {
    try {
      await AuthenticationService.signout()
      isAuthenticated.value = false
      member.value = {}
    } catch (error) {
      isAuthenticated.value = false
      member.value = {}
    }
  }

  const checkAuthentication = async () => {
    try {
      const response = await AuthenticationService.isAuthenticated()
      isAuthenticated.value = response.isAuthenticated
      member.value = response.isAuthenticated
        ? { memberId: response.memberId?.toString() }
        : {}
    } catch (error) {
      isAuthenticated.value = false
      member.value = {}
    }
  }

  const ssoSignin = async (memberId: string) => {
    try {      
        isAuthenticated.value = true
        member.value = {
          memberId: memberId
        }
    } catch (error) {
      throw error
    }
  }

  return {
    isAuthenticated,
    member,
    signup,
    signin,
    deepLinkSignin,
    signout,    
    checkAuthentication,
    ssoSignin
  }
})









